<template>
    <div @click="onClick(item)" class="field-column-setting">

      <vue-draggable-resizable :handles="['mr']" :w="w" :h="h"
                               :resizable="resizable"
                               :draggable="false"
                               :field_name="field_name"
                               @resizing="onResize"
                               :parent="parent"
                               :max-width="maxWidth"
                               :min-width="defaultWidth">
        <p class="display_width__text"> {{this.field_name}}</p>
        <div class="display_width">{{w}}px</div>
      </vue-draggable-resizable>
       <div class="vdr_height" :style="'width:' + w + 'px' "><p class="display_width__text"> {{this.field_name}}</p></div>
      <!-- <div v-if="true" class="eye_on"></div> <div v-if='false' class="eye_off"></div> -->
    </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

// Vue.component('vue-draggable-resizable', VueDraggableResizable)


export default {
  data: function () {
    return {
      width: 0,
      height: 0,
      Item: {},
      defaultWidth: 50,
      // x: 0,
      // y: 0
    }
  },
  props: {
    onClick: {
        type: Function
    },
    w: {
      type: Number
    },
    h: {
      type: Number
    },
    field_name: {
      type: String
    },
    item: {
      type: Object
    },
    resizable: {
      type: Boolean
    },
    parent: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: Number,
      default: 500
    }
  },
  components: {
    'vue-draggable-resizable': VueDraggableResizable
  },
  methods: {
    onResize: function (x, y, width, height) {
      //this.x = x
      //this.y = y
      this.$emit('changeWidth', width)
      // this.width = width
      // this.height = height
    },
    onDrag: function (x, y) {
      //this.x = x
      //this.y = y
    },
    // execute: function(){
    //   debugger
    //   // if (this.onClick) {
    //     this.onClick(this.item)
    //   // }
    // }
  }
}
</script>
